<template>
  <div close="credit-customer-sorter">
    <i-menu ref="myMenu" :trigger-align="setMenuAlignment" :width="menuWidth">
      <button
        slot="trigger"
        class="d-flex flex-column credit-customer-sorter__button"
      >
        <span class="up-arrow">
          <i-icon
            symbol="small-chevron-up"
            :size="16"
            :colour="
              isCurrentSortBy && !isCurrentSortDirectionAsc
                ? palette['light-neutral-120']
                : palette['light-neutral-100']
            "
          />
        </span>
        <span class="down-arrow">
          <i-icon
            symbol="small-chevron-down"
            :size="16"
            :colour="
              isCurrentSortBy && isCurrentSortDirectionAsc
                ? palette['light-neutral-120']
                : palette['light-neutral-100']
            "
          />
        </span>
      </button>

      <h3 slot="items" class="i-text-subheading-2 i-text-neutral-120 i-mx-4">
        Sort by
      </h3>
      <i-menu-item
        slot="items"
        :label="descLabel"
        :icon-color="palette['light-neutral-110']"
        icon="small-arrows-up-small"
        :checked="isCurrentSortBy && !isCurrentSortDirectionAsc"
        @item-click="updateSorting(sortBy, 'desc')"
      ></i-menu-item>

      <i-menu-item
        slot="items"
        :label="ascLabel"
        :icon-color="palette['light-neutral-110']"
        icon="small-arrows-down-small"
        :checked="isCurrentSortBy && isCurrentSortDirectionAsc"
        @item-click="updateSorting(sortBy, 'asc')"
      ></i-menu-item>
    </i-menu>
  </div>
</template>

<script>
import {
  iMenu,
  iMenuItem,
  iMenuTriggerAlignOptions,
  iIcon,
} from '@inscribe/signal';
import palette from '@inscribe/signal/dist/palette';
export default {
  components: {
    iIcon,
    iMenu,
    iMenuItem,
  },
  props: {
    menuWidth: {
      type: Number,
      default: 160,
    },
    menuAlign: {
      type: String,
      default: 'left',
    },
    currentSortBy: {
      type: String,
      required: true,
    },
    currentSortDirection: {
      type: String,
      required: true,
    },
    sortBy: {
      type: String,
      required: true,
    },
    ascLabel: {
      type: String,
      default: 'Earliest',
    },
    descLabel: {
      type: String,
      default: 'Latest',
    },
  },
  data() {
    return {
      palette,
    };
  },
  computed: {
    isCurrentSortBy() {
      return this.currentSortBy === this.sortBy;
    },
    isCurrentSortDirectionAsc() {
      return this.currentSortDirection === 'asc';
    },
    setMenuAlignment() {
      return this.menuAlign === 'right'
        ? iMenuTriggerAlignOptions.RIGHT
        : iMenuTriggerAlignOptions.LEFT;
    },
  },
  methods: {
    updateSorting(sortBy, sortDirection) {
      this.$emit('update-sorting', { sortBy, sortDirection });
    },
  },
};
</script>

<style lang="scss" scoped>
.credit-customer-sorter {
  &__button {
    border: none;
    background-color: transparent;
    padding: 0;
    margin: 0;
    outline: none;
    cursor: pointer;

    .up-arrow,
    .down-arrow {
      height: 10px;
      overflow: hidden;

      svg {
        margin-top: -2px;
      }
    }
  }
}
</style>
